import { PersonPage } from '../components/PersonPage';

export function Bride() {
  return (
    <PersonPage
      role="The Bride"
      name="Lynne Tey"
      tagline="A kind heart, a gentle soul, and a love for life's little joys."
      bio="Lynne is a Malaysian-born dentist with a kind heart, gentle soul, and a love for the little joys in life. Since moving to Australia, she has built a beautiful new chapter with courage, warmth, and grace. She is thoughtful, caring, and brings light to the people around her."
      interests={[]}
      hero="/people/bride-1.jpeg"
      gallery={[
        '/people/bride-2.jpeg',
        '/people/bride-3.jpeg',
        '/people/bride-4.jpeg',
        '/people/bride-5.jpeg',
      ]}
    />
  );
}
